import React, { useEffect, useState } from "react";
import {
  Table,
  Input,
  Button,
  Popconfirm,
  Form,
  Space,
  Col,
  Row,
  message,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { PlusOutlined } from "@ant-design/icons";
import { ReactComponent as EditIcon } from "../../assets/edit-icon.svg";
import { ReactComponent as DeleteIcon } from "../../assets/delete-icon.svg";
import { ReactComponent as SaveIcon } from "../../assets/save-icon.svg";
import SpinnerComponent from "../../components/spinner";
import {
  fetchDocumentField,
  isAddingAction,
  updateDocumentField,
} from "../DefaultDocumentFields/redux/actions";
import _ from "lodash";

const DocumentTable = ({ canUpdate }) => {
  const [loading, setLoading] = useState(false);
  const [editingLoading, setEditingLoading] = useState(false);
  const [editingKey, setEditingKey] = useState("");
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [data, setData] = useState([]);
  const isEditing = (record) => record.id === editingKey;

  const { allDocumentField, fetchingLoading, updateLoading, isAdding } =
    useSelector((state) => state.documentFieldReducer);

  useEffect(() => {
    dispatch(fetchDocumentField());

    return () => {
      dispatch(isAddingAction(false));
    };
  }, []);

  useEffect(() => {
    setData(allDocumentField);
  }, [allDocumentField]);

  useEffect(() => {
    setEditingLoading(updateLoading);
    if (!updateLoading) {
      setEditingKey("");
    }
  }, [updateLoading]);

  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  }) => {
    const inputNode = (
      <Input
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            save(record.id);
          }
        }}
      />
    );
    return (
      <td {...restProps}>
        {editing ? (
          <div>
            <div className="field-text">FIELD {index + 1} NAME</div>
            <Form.Item
              name={dataIndex}
              style={{
                margin: 0,
              }}
              rules={[
                {
                  required: true,
                  message: `Required!`,
                },
              ]}
            >
              {inputNode}
            </Form.Item>
          </div>
        ) : (
          children
        )}
      </td>
    );
  };

  const edit = (record) => {
    dispatch(isAddingAction(true));

    form.setFieldsValue(record);
    setEditingKey(record.id);
  };

  const cancel = (record) => {
    dispatch(isAddingAction(false));
    setData(data);
    form.resetFields();
    setEditingKey("");
  };

  const save = async (id) => {
    try {
      const row = await form.validateFields();
      const newData = [...data];
      const index = newData.findIndex((item) => id === item.id);

      if (index > -1) {
        const item = newData[index];
        dispatch(updateDocumentField({ ...item, ...row }));
      } else {
        newData.push(row);
        setData(newData);
        setEditingKey("");
      }
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
      message.error("Name should not be blank!");
    }
  };

  const hanldeFinish = ({ name }) => {
    if (name.trim().length < 1) {
      return message.error("Name should not be blank.");
    }

    let filtered = data.filter(
      (el) => el.name.toLowerCase() === name.toLowerCase()
    );

    if (filtered.length > 0) {
      return message.error("Name has already been taken.");
    }

    // dispatch(createDepartment({ name: name.trim() }));
  };

  const columns = [
    {
      title: "",
      key: "name",
      dataIndex: "name",
      width: "90%",
      editable: true,
      render: (name, record, index) => {
        return (
          <div>
            <div className="field-text">FIELD {index + 1} NAME</div>
            <div>{name}</div>
          </div>
        );
      },
    },
    {
      title: "",
      key: "action",
      dataIndex: "",
      width: "10%",
      align: "left",
      className: "action-col",
      render: (_, record) => {
        if (!canUpdate) {
          return;
        }
        if (!record?.editable) {
          return;
        }

        const editable = isEditing(record);
        return editable ? (
          editingLoading && editingKey === record.id ? (
            <SpinnerComponent fontSize={14} />
          ) : (
            <Space size={15} align="center">
              <SaveIcon
                className="custom-icon"
                onClick={() => save(record.id)}
              />
              {/* <Popconfirm
                title="Sure to cancel?"
                onConfirm={() => cancel(record)}
              >
                <DeleteIcon className="custom-icon" />
              </Popconfirm> */}
            </Space>
          )
        ) : (
          <EditIcon
            className="custom-icon"
            disabled={editingKey !== ""}
            onClick={() => edit(record)}
          />
        );
      },
    },
  ];

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record, index) => ({
        record,
        inputType: "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
        index,
      }),
    };
  });

  return (
    <Row className="production-manager-parent-row">
      <Col span={24} className="heading-col">
        <div>
          <span className="heading-span">Default Document Fields</span>
        </div>
      </Col>
      <Col span={12} offset={3}>
        <Form form={form} component={false} onFinish={hanldeFinish}>
          <Table
            className="special-table default-doc-field-table"
            components={{
              body: {
                cell: EditableCell,
              },
            }}
            showHeader={false}
            style={{ width: "450px" }}
            scroll={{ x: true }}
            rowClassName="editable-row"
            dataSource={data}
            loading={fetchingLoading}
            columns={mergedColumns}
            pagination={false}
          />
        </Form>
      </Col>
    </Row>
  );
};

export default DocumentTable;
